import React from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';

import DashboardBase from '../../components/DashboardBase/DashboardBase';

const PublicRoute = ({ isDashboardBase, isPublic }) => {
  const currentUser = useSelector((state) => state.authReducer.currentUser);
  const authenticated = !!currentUser;
  if (!isPublic && authenticated && isDashboardBase) {
    return (
      <DashboardBase>
        <Outlet />
      </DashboardBase>
    );
  }
  return <Outlet />;
};

export default PublicRoute;
